import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import qs from 'querystring';
import { takeLatest, call, put, all } from 'redux-saga/effects';

import { t } from '~/helpers';
import api from '~/services/api';
import history from '~/services/history';

import {
  successInRequest,
  failedRequest,
  successRemove,
  successRequest,
} from './actions';

export function* requestTanquesFisicos({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'tanquesfisicos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });
    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* deleteTanqueFisico({ payload }) {
  try {
    const { idtanquefisico, params } = payload;

    yield call(api.delete, `tanquesfisicos/${idtanquefisico}`);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoexclusao'));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(t(e)));
    else toast.error(t(erros));
  }
}

export function* store({ payload }) {
  try {
    const { tanquefisico, params } = payload;

    yield call(api.post, 'tanquesfisicos', tanquefisico);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoinclusao'));
    history.push('/tanquesfisicos');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* find({ payload }) {
  try {
    const { idtanquefisico } = payload;

    const { data } = yield call(api.get, `tanquesfisicos/${idtanquefisico}`);
    yield put(successRequest(data));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* update({ payload }) {
  try {
    const { tanquefisico, params } = payload;

    yield call(api.put, 'tanquesfisicos', tanquefisico);
    yield put(successRemove({ ...params, pesquisalista: true }));

    toast.success(t('s.geral.sucessoalteracao'));
    history.push('/tanquesfisicos');
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export function* applyedFilters({ payload }) {
  try {
    const { params } = payload;
    const response = yield call(api.get, 'tanquesfisicos', {
      params,
      paramsSerializer: (param) => qs.stringify(param),
    });

    const { items, page, pageSize, totalCount, totalPages } = response.data;

    yield put(successInRequest(items, page, pageSize, totalCount, totalPages));
  } catch (erros) {
    yield put(failedRequest());
    if (isArray(erros)) erros.map((e) => toast.error(e));
    else toast.error(erros);
  }
}

export default all([
  takeLatest(
    '@tanquesfisicos/TANQUESFISICOS_IN_REQUEST',
    requestTanquesFisicos
  ),
  takeLatest('@tanquesfisicos/DELETE_TANQUEFISICO', deleteTanqueFisico),
  takeLatest('@tanquesfisicos/SUCCESS_REMOVE', requestTanquesFisicos),
  takeLatest('@tanquesfisicos/STORE_TANQUEFISICO', store),
  takeLatest('@tanquesfisicos/FIND_TANQUEFISICO', find),
  takeLatest('@tanquesfisicos/UPDATE_TANQUEFISICO', update),
  takeLatest('@tanquesfisicos/RECORD_FILTERING', applyedFilters),
]);
